import { whenAll, whenNot } from 'platform/shared/health-apps';
import BeneficiaryInfoPage from '../../components/FormPages/BeneficiaryInfoPage';
import EnrollmentCheckFailedPage from '../../components/FormPages/EnrollmentCheckFailedPage';
import EnrollmentStatusReview from '../../components/FormReview/EnrollmentStatusReview';
import { blankSchema } from '../../definitions';
import {
  enrollmentCheckEnabled,
  enrollmentCheckPassed,
  isExistingSubmission,
  roleIsOther,
  showSponsorEntry,
  showSubmitOhiOverview,
  showSupplementalOverview,
} from '../../utils/helpers';
import { sponsorPrefillPage } from '../../utils/pageBuilders';
import applicantInformation from './applicantInformation';
import applicantSsn from './applicantSsn';
import contactInformation from './contactInformation';
import contactName from './contactName';
import enrollmentStatus from './enrollmentStatus';
import sectionOverview from './sectionOverview';
import sponsorInformation from './sponsorInformation';
import sponsorSsn from './sponsorSsn';
import submitOhiOverview from './submitOhiOverview';
import { supportingDocPages } from './supportingDocs';
import updateType from './updateType';

export const supplementalPages = {
  primaryContactName: {
    path: 'primary-contact-name',
    title: 'Your Name',
    depends: roleIsOther,
    ...contactName,
  },
  primaryContactInformation: {
    path: 'primary-contact-information',
    title: 'Your contact information',
    ...contactInformation,
  },
  supplementalUpdateType: {
    path: 'additional-health-insurance',
    title: 'Other health insurance information',
    ...updateType,
  },
  supplementalOverview: {
    path: 'update-overview',
    title: 'Supporting information',
    depends: showSupplementalOverview,
    ...sectionOverview,
  },
  submitOhiOverview: {
    path: 'submit-ohi-overview',
    title: 'Supporting information',
    hideNavButtons: true,
    depends: showSubmitOhiOverview,
    ...submitOhiOverview,
  },
  supplementalApplicantPersonalInfo: {
    path: 'beneficiary-name-and-date-of-birth',
    title: 'Beneficiary’s name and date of birth',
    depends: whenNot(enrollmentCheckEnabled),
    ...applicantInformation,
  },
  supplementalApplicantIdentityInfo: {
    path: 'beneficiary-identification-information',
    title: 'Beneficiary’s identification information',
    depends: whenNot(enrollmentCheckEnabled),
    ...applicantSsn,
  },
  supplementalBeneficiaryPersonalInfo: {
    path: 'beneficiary-personal-information',
    title: 'Beneficiary’s personal information',
    depends: enrollmentCheckEnabled,
    CustomPage: BeneficiaryInfoPage,
    CustomPageReview: EnrollmentStatusReview,
    ...enrollmentStatus,
  },
  supplementalEnrollmentStatus: {
    path: 'beneficiary-enrollment-status',
    title: 'CHAMPVA enrollment status',
    depends: whenAll(enrollmentCheckEnabled, whenNot(enrollmentCheckPassed)),
    CustomPage: EnrollmentCheckFailedPage,
    CustomPageReview: null,
    uiSchema: {},
    schema: blankSchema,
  },
  ...sponsorPrefillPage({
    key: 'supplementalSponsorPrefill',
    path: 'veteran-personal-information-update',
  }),
  supplementalSponsorPersonalInfo: {
    path: 'veteran-name-and-date-of-birth-update',
    title: `Veteran’s name and date of birth`,
    depends: whenAll(isExistingSubmission, showSponsorEntry),
    ...sponsorInformation,
  },
  supplementalSponsorIdentityInfo: {
    path: 'veteran-identification-information-update',
    title: 'Veteran’s identification information',
    depends: whenAll(isExistingSubmission, showSponsorEntry),
    ...sponsorSsn,
  },
  ...supportingDocPages,
};
